import React from 'react';
import { Text, View, Image } from 'react-native';
import { detailsStyles } from '../styles/details';
import Star from 'react-native-vector-icons/FontAwesome';
import BackBtn from 'react-native-vector-icons/FontAwesome';
import LikeBtn from 'react-native-vector-icons/FontAwesome';
import CartIcon from 'react-native-vector-icons/Feather';
import { useNavigation, useRoute } from '@react-navigation/native';


const Details = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const { restaurant } = route.params;
  



  return (
    <View style={detailsStyles.detailWrapper}>
      <View style={detailsStyles.topIcon}>
        <BackBtn
          name="angle-left"
          style={detailsStyles.back}
          onPress={() => navigation.navigate('Home')}
        />
        <CartIcon name="shopping-cart" style={detailsStyles.heart} />
      </View>

      <View>
        <Text style={detailsStyles.brand}>{restaurant.title}</Text>
        <View>
          <Image
            source={{ uri: restaurant.image_url }}
            style={detailsStyles.dPic}
          />
          <View style={detailsStyles.circle}>
            <LikeBtn name="heart-o" style={detailsStyles.heart} />
          </View>
        </View>
        <Text style={detailsStyles.desc}>{restaurant.description}</Text>
        <View style={detailsStyles.starWrapper}>
          <View style={detailsStyles.rate}>
            <Star name="star" style={detailsStyles.star} />
            <Text style={detailsStyles.rate}>{restaurant.rating}</Text>
          </View>

          <Text style={detailsStyles.price}>Ksh. {restaurant.price}</Text>
         
        </View>
      </View>
    </View>
  );
  
};

export default Details;
